import React, { useState } from 'react';
import { couponService } from '../../services/couponService';
import BaseModal from '../common/BaseModal';

function ManualReceiptModal({ coupon, isOpen, onClose, onSuccess }) {
  const [receiptNumber, setReceiptNumber] = useState(coupon?.numer_paragonu || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!coupon) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await couponService.updateReceiptNumber(coupon.id, receiptNumber);
      onSuccess && onSuccess();
      onClose();
    } catch (err) {
      setError('Błąd podczas zapisu numeru paragonu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Edytuj numer paragonu"
      size="sm"
      zIndex={1000}
      headerIcon={
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/></svg>
      }
      headerStyle={{
        border: '1px solid var(--info)',
        color: 'var(--info)',
      }}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '6px 12px',
              background: 'var(--bg)',
              color: 'var(--text)',
              border: '1px solid var(--border)',
              fontWeight: 500,
              fontSize: '12px',
            }}
          >
            Anuluj
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            style={{
              padding: '6px 12px',
              border: `1px solid ${loading ? 'var(--info-light)' : 'var(--info)'}`,
              color: 'var(--info)',
              fontWeight: 600,
              fontSize: '12px',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Zapisuję...' : 'Zapisz'}
          </button>
        </>
      }
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        <label htmlFor="receiptNumber" style={{ fontWeight: 500, fontSize: 15, color: 'var(--text)', marginBottom: 6, display: 'block' }}>Numer paragonu</label>
        <input
          id="receiptNumber"
          type="text"
          value={receiptNumber}
          onChange={e => setReceiptNumber(e.target.value)}
          placeholder="Wpisz numer paragonu"
          style={{
            width: '100%',
            padding: '12px 14px',
            margin: '8px 0 18px 0',
            border: '1.5px solid var(--border)',
            borderRadius: 7,
            fontSize: 17,
            outline: 'none',
            boxSizing: 'border-box',
            background: 'var(--bg)',
            transition: 'border 0.2s',
            fontWeight: 500
          }}
          required
        />
        {error && <div style={{ color: 'var(--danger)', background: 'var(--danger-light)', borderRadius: 5, padding: '8px 12px', marginBottom: 14, fontSize: 15 }}>{error}</div>}
      </form>
    </BaseModal>
  );
}

export default ManualReceiptModal;
